import React, { useEffect, useState } from 'react'
import ReactPlayer from "react-player";
import video from "../../img/308559.mp4"
import "./hero.scss";
import HeroTags from '../heroTags/HeroTags';
import mobile from "../../img/mobile.jpg";


const Hero = () => {

   const [isDesktop, setIsDesktop] = useState(window.innerWidth > 900);

   useEffect(() => {
     const handleResize = () => {
       setIsDesktop(window.innerWidth > 900);
     };

     window.addEventListener("resize", handleResize);
     return () => window.removeEventListener("resize", handleResize);
   }, []);


  return (
    <div className="__fw">
      <div className="hero_wrp">
        {/* MOBILE IMAGE */}
        {!isDesktop && (
          <div
            className="mobile"
            style={{
              backgroundImage: `url(${mobile})`,
              height: "70dvh",
              width: "100dvw",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          />
        )}

        {/* DESKTOP VIDEO */}
        {isDesktop && (
          <ReactPlayer
            className="video"
            src={video}
            playing
            loop
            muted
            playsinline
            controls={false}
            width="100%"
            height="100%"
          />
        )}
        <div className="over_flow">
          <div className="__fw">
            <div className="__mw">
              <div className="hero_tag">
                <h1>
                  Breaking the Rules <br />{" "}
                  <em>The New Era of Financial Freedom</em>
                </h1>
              </div>
              <div className="sub_text">
                <p>
                  Welcome to the explosive monetary revolution that Wall Street
                  and traditional bankers would rather you not know about. At
                  intellitech, we're bridging the critical pillars of trading
                  success through our hybrid approach that combines human
                  expertise with cutting-edge technology
                </p>
              </div>
              {/* <HeroTags /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero
